import { render, staticRenderFns } from "./MakePaymentTermsStep.vue?vue&type=template&id=20685814&scoped=true&"
import script from "./MakePaymentTermsStep.vue?vue&type=script&lang=ts&"
export * from "./MakePaymentTermsStep.vue?vue&type=script&lang=ts&"
import style0 from "./MakePaymentTermsStep.vue?vue&type=style&index=0&id=20685814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20685814",
  null
  
)

export default component.exports